import { DefaultRow } from "@pdf/helpers/default-row/default-row";
import { jsPDF } from "jspdf";

export class WireRow extends DefaultRow {
  readonly number: string[];
  readonly displayName: string[];
  readonly name: string[];
  readonly type: string[];
  readonly referenceLength: string[];
  readonly notes: string[];

  public constructor(
    pdf: jsPDF,
    number: string[],
    displayName: string[],
    name: string[],
    type: string[],
    referenceLength: string[],
    notes: string[],
  ) {
    super();
    this.number = number;
    this.displayName = displayName;
    this.name = name;
    this.type = type;
    this.referenceLength = referenceLength;
    this.notes = notes;
    this._textHeight = this.calculateRowTextHeight(pdf);
    this._rowHeight = this.calculateRowHeight(this.textHeight);
  }

  public calculateRowTextHeight(pdf: jsPDF) {
    return Math.max(
      ...[
        this.calculateCellTextHeight(pdf, this.number),
        this.calculateCellTextHeight(pdf, this.displayName),
        this.calculateCellTextHeight(pdf, this.name),
        this.calculateCellTextHeight(pdf, this.type),
        this.calculateCellTextHeight(pdf, this.referenceLength),
        this.calculateCellTextHeight(pdf, this.notes),
      ],
    );
  }
}
